/**
 * Scrolls the given HTML element to the specified absolute position animated with an easing over a certain duration.
 *
 * The technique used is inspired by the following two articles:
 * - https://coderwall.com/p/hujlhg/smooth-scrolling-without-jquery
 * - http://blog.greweb.fr/2012/02/bezier-curve-based-easing-functions-from-concept-to-implementation/
 *
 * @param {HTMLElement} element The HTML element to scroll.
 * @param {Number} offset The absolute position the given element should scroll to.
 * @param {any} duration The duration of the scroll animation.
 */
function stride(element, offset, duration) {
  duration = duration || 1000
  var userScrollInterception = false
  var scrollInterceptionHandler = function() {
    userScrollInterception = true
  }

  window.addEventListener('wheel', scrollInterceptionHandler, { once: true })
  window.addEventListener('touchmove', scrollInterceptionHandler, { once: true })

  if (duration < 0) {
    return
  }

  var start = element.scrollTop
  var end = start + offset

  if (Math.floor(end - start) === 0) {
    return
  }

  var easeInOutCubic = function(t) {
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1
  }

  var position = function(start, end, elapsed, duration) {
    if (elapsed > duration) {
      return end
    }
    return Math.round(start + (end - start) * easeInOutCubic(elapsed / duration))
  }

  var clock = Date.now()

  var requestAnimationFrame =
    window.requestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    function(fn) {
      window.setTimeout(fn, 15)
    }

  // eslint-disable-next-line no-unused-vars
  var currentPosition = element.scrollTop

  var step = function() {
    var elapsed = Date.now() - clock
    var newPosition = position(start, end, elapsed, duration)

    if (userScrollInterception) {
      return
    }

    currentPosition = newPosition
    element.scrollTop = newPosition

    if (elapsed > duration) {
      return
    }

    requestAnimationFrame(step)
  }
  step()
}

export default stride
